/**
 * UnauthorizedPage — shown when a signed-in account is not PazNetworks
 * staff. The session is signed out on arrival so the next visit starts
 * clean and a staff account can be used instead.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function UnauthorizedPage() {
  const { session, signOut } = useAuth();
  const [signOutError, setSignOutError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    let cancelled = false;
    signOut().catch((err: unknown) => {
      if (cancelled) return;
      setSignOutError(err instanceof Error ? err.message : 'Sign-out failed.');
    });
    return () => {
      cancelled = true;
    };
  }, [session, signOut]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="text-center max-w-sm">
        <h1 className="text-4xl font-semibold text-text">403</h1>
        <p className="text-sm text-text-muted mt-2">
          The Estimator is available to PazNetworks staff accounts only. You have been signed out.
        </p>
        {signOutError && (
          <p className="text-xs text-error mt-2" role="alert">
            Could not end the session automatically: {signOutError}
          </p>
        )}
        <Link
          to="/login"
          className="inline-flex min-h-11 items-center mt-4 text-sm text-primary underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-sm px-2"
        >
          Sign in with a staff account
        </Link>
      </div>
    </div>
  );
}
